<template>
    <dropzone url="/system-settings/co2/upload"
              :success-event="successEvent"
              :fail-event="failEvent"
              v-if="! jobMonitor"
    ></dropzone>
    <div v-else>
        <h2>Data Import in Progress</h2>
        <div class="ProgressBar">
            <div class="ProgressBar__status">Status: {{ jobMonitor.message }}</div>
            <div class="ProgressBar__bar">
                <div :class="progressBarClasses" :style="progress"></div>
            </div>
            <div class="ProgressBar__count">Completed {{ jobMonitor.completed }} of {{ jobMonitor.tasks }} tasks.</div>
        </div>

        <a href="#" class="Button" @click.prevent="resetForm" v-show="finished">Upload Another File</a>
    </div>
</template>

<script>
    import FileUploader from './../mixins/fileUploader';

    export default {
        mixins: [FileUploader],
    }
</script>